import React, { useEffect } from "react";
import styled from "styled-components";
import MuuriGrid from "muuri";
import "./style.css";

import RoomCard from "./room-card";
import { Col, Row, Box, Text } from "../../../comps";
import { Theme } from "../../../theme/theme-provider";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  align-items: center;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.color.GRAY_2};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.GRAY_1};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb:hover {
  }
`;

const Head = styled(Row)`
  width: 90%;
  margin-top: 30px;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
`;

const RoomList = styled(Box)`
  width: 90%;
  margin-top: 20px;
`;

export default ({ rooms }) => {
  useEffect(() => {
    if (
      rooms &&
      rooms.length > 0 &&
      document.getElementsByClassName("roomsGrid").length > 0
    ) {
      const grid = new MuuriGrid(".roomsGrid", {
        dragEnabled: true,
        rounding: true,
        layout: { fillGaps: true, alignLeft: true, alignTop: true },
      });
    }
  }, [rooms]);

  return (
    <Wrapper>
      <Head>
        <Text
          fontSize="24px"
          fontWeight={600}
          color={Theme.color.GRAY_1}
        >{`Your Rooms`}</Text>
      </Head>
      <RoomList>
        <div class="grid roomsGrid">
          {rooms.map((room) => {
            return <RoomCard room={room} />;
          })}
        </div>
      </RoomList>
    </Wrapper>
  );
};
